import dayjs from 'dayjs';

export type FileMetaSource = {
    created?: string | Date | null;
    createdAt?: string | Date | null;
    date?: string | Date | null;
    lastModified?: string | Date | null;
    size?: number | null;
};

export function formatFileSize(bytes?: number | null) {
    if (bytes == null) return '';
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export function formatFileDate(date?: string | Date | null) {
    if (!date) return '';

    const parsedDate = dayjs(date);
    if (!parsedDate.isValid()) return '';

    return parsedDate.format('DD MMM, YYYY');
}

export function getFileMetaText(file?: FileMetaSource | null) {
    if (!file) return '';

    const sizeText = formatFileSize(file.size);
    const dateText = formatFileDate(
        file.date ?? file.created ?? file.createdAt ?? file.lastModified,
    );

    if (sizeText && dateText) return `${sizeText} | ${dateText}`;
    return sizeText || dateText;
}
